export const getMatchValueArray = (object, matcher) => {
  const result = [];
  const objectKeys = Object.keys(object);
  objectKeys.forEach(value => {
    if (matcher.test(value)) {
      result.push(object[value]);
    }
  });
  return result;
};

export const getRem = px => {
  return px / 1000 + 'rem';
};

